<template>
  <!-- 移動端Web技能詳情 -->
  <div class="scroll-wrap">
    <div class="loading-container" v-if="loadingViewMasterInfo">
      <i class="el-icon-loading"></i>
    </div>
    <div v-else class="skill-detail-dialog">
      <div ref="page_top" class="page-top" />
      <div v-if="!masterDialog" class="skill-detail-title">
        <fps-avatar class="user-image" :class="!quickMatchUuid && 'pointer'" :src="skillInfo.avatarImageUrl" @click.native="openMasterDetail()" />
        <span class="nickname" :class="!quickMatchUuid && 'pointer'" @click="openMasterDetail()">{{ skillInfo.nickname }}</span>
        <div v-if="isOnline" class="online-circle-wrap" :class="isOnline && 'is-online-wrap'"/>
        <span class="online-text">{{ isOnline ? $t('upgrade_page_views_master_index_206') : $t('upgrade_page_views_player_detail_index_1105') }}</span>
        <!-- <span class="reply-count">及時回覆率%</span> -->
      </div>
      <div class="skill-top">
        <img v-if="masterDialog" class="game-image" :src="skillInfo.gameImageUrl + '?d=300x300'" >
        <PhotoList
          v-else
          class="photo-list"
          :width="displayWidth"
          :isLoading="loadingViewMasterInfo"
          :masterInfo="viewMasterInfo"
          :photoList="[skillInfo.avatarImageUrl]"
        />
        <div class="skill-info">
          <div class="skill-name">{{ skillInfo.gameName }}</div>
          <div class="order-state">
            <div class="order-count">{{$t('components_skilldetail_index_1760')}}<span class="stronger">{{ skillInfo.countTransactions }}</span>{{$t('filters_index_74')}}</div>
            <div class="line" />
            <fps-star
              :count="skillInfo.starRating"
              :size="12"
            />
            <span v-if="skillInfo.starRating" class="order-score">
              {{ skillInfo.starRating | parseNum(1) }}
              <span v-if="skillInfo.countComment">({{ skillInfo.countComment }})</span>
            </span>
          </div>
          <div class="display-price">
            <div class="price">
              <span class="sale-price">{{ selectedModel.showPrice }}</span>
              <span class="sale-price">{{$t('upgrade_page_views_home_suggest_item_4')}}</span>
              <span class="sale-unit">/{{ selectedModel.salesUnit | salesUnitTranslate  }}</span>
              <span v-if="selectedModel.showPrice !== selectedModel.price" class="old-price">{{$t('upgrade_page_views_master_components_skill_info_base_info_253', [ selectedModel.price , selectedModel.salesUnit | salesUnitTranslate  ])}}</span>
            </div>
            <div
              v-if="skillInfo.redBagFreeFlag && selectedModel.showPrice === 1"
              class="price-onecoin"
            >
              <div><span>{{$t('upgrade_page_views_player_list_player_item_173')}}</span>{{$t('upgrade_page_views_master_components_skill_info_base_info_254')}}</div>
            </div>
            <div v-else class="discount-list">
              <div
                v-for="(d,i) in discountList"
                :key="`discount-${i}`"
                class="one-discount"
              >{{ d }}</div>
            </div>
          </div>
          <div class="discount-price" />
          <template v-if="skillInfo.skillPriceList && skillInfo.skillPriceList.length">
            <div class="select-wrap select-price">
              <div class="select-left">{{$t('upgrade_page_views_order_components_price_unit_303')}}</div>
              <div class="select-right">
                <div class="model-price" :class="!selectedModel.id && 'selected'" @click="selectPrice()">
                  <span class="model-name">{{$t('upgrade_page_views_master_components_skill_info_base_info_269')}}</span>
                  <span class="price">{{$t('upgrade_page_views_master_components_skill_info_base_info_253', [ skillInfo.salesPrice , skillInfo.salesUnit | salesUnitTranslate ])}}</span>
                </div>
                  <div
                    v-for="(p, i) in skillInfo.skillPriceList"
                    :key="'price' + (i + 1)"
                    class="model-price"
                    :class="selectedModel.id === p.id && 'selected'"
                    @click="selectPrice(p)"
                  >
                    <span class="model-name">{{ p.name }}</span>
                    <span class="price">{{$t('upgrade_page_views_master_components_skill_info_base_info_253', [ p.price , p.salesUnit | salesUnitTranslate ])}}</span>
                  </div>
              </div>
            </div>
          </template>
          <!-- <div v-if="!isSelf" class="select-wrap select-count">
            <div class="select-left">數量</div>
            <div class="select-right">
              <InputNumber
                v-model="orderCount"
                :disabled="!!quickMatchUuid"
              />
            </div>
          </div> -->
          <div v-if="skillInfo.giveAwayList && skillInfo.giveAwayList.length && !newComerCouponList[0]" class="select-wrap give-away">
            <div class="select-left">{{$t('upgrade_page_views_order_components_gift_with_purchase_324')}}</div>
            <div class="select-right">
              <div
                v-for="(g, i) in skillInfo.giveAwayList"
                :key="`give-away${i}`"
                class="one-give-away"
              >{{ $t('upgrade_page_views_master_components_skill_info_base_info_255',[g.startNum,g.giftNum]) }}</div>
            </div>
          </div>
          <div v-if="!isSelf && !quickMatchUuid && !loadingViewMasterInfo" ref="tool_button_bottom" class="tool-buttons">
            <button class="chat-btn" @click="openChat">
              <fps-icon type="message" size="18" />
              <span class="chat-btn-text">{{$t('upgrade_page_views_master_components_skill_info_base_info_267')}}</span>
            </button>
            <button class="order-btn" @click="openOrderPage">{{$t('upgrade_page_views_master_components_skill_info_base_info_268')}}</button>
          </div>
        </div>
      </div>
      <div class="skill-description">
        <div class="detail-title">{{$t('components_skilldetail_index_1762')}}</div>
        <fps-voice
          v-if="skillInfo.voiceUrl"
          class="skill-voice"
          :src="skillInfo.voiceUrl"
          :color="skillInfo.sex === 'Female' ? '#EC5375' : '#5362EC'"
          :control="true"
        />
        <div class="description-text">{{ skillInfo.description }}</div>
        <div v-if="labelList.length" class="skill-description-tags">
          <div class="tags-list">
            <div
              v-for="(l, i) in labelList"
              :key="'label-' + (l.labelId || i)"
              :class="l.classes"
            >{{ l.onlyShowIamge ? '' : l.name }}</div>
          </div>
          <TipBtn
            width="280"
          >
            <div class="label-text">
              <div class="title">{{$t('upgrade_page_views_master_components_skill_info_base_info_259')}}</div>
              <ul>
                <li>
                  <div class="custom-tag rebought tag-wrap">{{$t('upgrade_page_views_player_list_index_195')}}</div><span>{{$t('upgrade_page_views_master_components_skill_info_base_info_260')}}</span>
                </li>
                <li>
                  <div class="custom-tag nice tag-wrap">{{$t('upgrade_page_views_player_list_index_198')}}</div><span>{{$t('upgrade_page_views_master_components_skill_info_base_info_261')}}</span>
                </li>
                <li>
                  <div class="custom-tag hot tag-wrap">{{$t('upgrade_page_views_player_list_index_199')}}</div><span>{{$t('upgrade_page_views_master_components_skill_info_base_info_262')}}</span>
                </li>
                <li v-if="labelList && labelList.some(v=>v.name==$t('upgrade_page_views_player_list_index_200'))">
                  <div class="custom-tag new tag-wrap">{{$t('upgrade_page_views_player_list_index_200')}}</div><span>{{$t('upgrade_page_views_master_components_skill_info_base_info_263')}}</span>
                </li>
                <li v-if="showLolTag">
                  <div class="comment-tag top tag-wrap">{{$t('upgrade_page_views_master_components_skill_info_base_info_264')}}</div><span>{{$t('upgrade_page_views_master_components_skill_info_base_info_265')}}</span>
                </li>
              </ul>
            </div>
          </TipBtn>
        </div>
        <div class="line" />
        <div v-if="skillInfo.gameLevelString" class="skill-attr">
          <div class="skill-attr-name">{{$t('upgrade_page_views_player_list_index_178')}}</div>
          <div class="skill-attr-value">{{ skillInfo.gameLevelString }}</div>
        </div>
        <template v-if="skillInfo.gamePropertyMap">
          <div
            v-for="(v, a) in skillInfo.gamePropertyMap"
            :key="`skill-attr${a}`"
            class="skill-attr"
          >
            <div class="skill-attr-name">{{ v.propertyName }}</div>
            <div class="skill-attr-value">{{ v.propertyValueList.join(' ') }}</div>
          </div>
        </template>
        <div v-if="screenshotImageUrlList.length" class="custom-swiper custom-swiper-banner">
          <el-carousel
            ref="banner"
            class="banner-logined"
            height="193px"
            :autoplay="false"
            trigger="click"
            arrow="never"
            :loop="false"
            :indicator-position="screenshotImageUrlList.length > 1 ? '' : 'none'"
            @change="changeSwipe"
          >
            <el-carousel-item
              v-for="(item, i) in screenshotImageUrlList"
              :key="skillInfo.id + '-image' + i"
            >
              <fps-scale-img
                :src="item + '?d=686x340'"
                :imageList="screenshotImageUrlList"
                :defaultIndex="i"
                borderRadius="4px"
              />
            </el-carousel-item>
          </el-carousel>
          <div v-show="swipeIndex !== 0" class="custom-arrow custom-arrow-left" @click="swipeChange('prev', 'banner')">
            <fps-icon type="arrow-left" size="24" />
          </div>
          <div v-show="swipeIndex < screenshotImageUrlList.length - 1" class="custom-arrow custom-arrow-right" @click="swipeChange('next', 'banner')">
            <fps-icon type="arrow-right" size="24" />
          </div>
        </div>
        <div v-if="skillInfo.certificationExtraData && skillInfo.certificationExtraData.kda !== null && skillInfo.certificationExtraData.kda !== undefined" class="pubg-kda">
          <img class="nicee-certification" src="~@/assets/image/icons/shield-blue.png">
          <span>{{ skillInfo.certificationExtraData.gameMode | parseGameMode }}</span>
          <span>{{$t('components_skilldetail_index_1763', [ skillInfo.certificationExtraData.roundsPlayed ])}}</span>
          <span>KDA{{ skillInfo.certificationExtraData.kda }}</span>
        </div>
      </div>
      <div v-if="!isSelf && !quickMatchUuid" class="master-info">
        <div class="detail-title">{{$t('components_skilldetail_index_1764')}}</div>
        <div class="master-info-wrap">
          <div class="master-info-wrap-left">
            <div class="user-avatar">
              <fps-avatar class="pointer" :src="skillInfo.avatarImageUrl" @click.native="openMasterDetail()" />
              <div v-if="isOnline" class="online-state" :class="isOnline && 'is-online-wrap'" />
            </div>
            <div class="master-info-wrap-left-other">
              <div class="user-nickname pointer" @click="openMasterDetail()">{{ skillInfo.nickname }}</div>
              <div class="tool-btns">
                <button class="chat-btn" @click="openChat">
                  <fps-icon type="message" size="12" />
                  <span class="chat-btn-text">{{$t('upgrade_page_views_master_components_skill_info_base_info_267')}}</span>
                </button>
                <button class="detail-btn" @click="openMasterDetail()">{{$t('components_skilldetail_index_1765')}}</button>
              </div>
            </div>
          </div>
          <div v-if="loadingViewMasterInfo" class="master-info-wrap-right loading-wrap">
            <div class="data-wrap-name">
              <div>{{$t('upgrade_page_views_player_detail_index_1109')}}</div>
              <div>{{$t('upgrade_page_views_player_detail_index_1110')}}</div>
            </div>
            <div class="data-wrap-value">
              <div>--</div>
              <div>--</div>
            </div>
            <div class="data-wrap-name">
              <div>
                <span>{{$t('upgrade_page_views_master_index_210')}}</span>
                <fps-icon type="question" size="18" color="rgba(99, 109, 134, 0.5)" />
              </div>
              <div>{{$t('upgrade_page_views_master_index_209')}}</div>
            </div>
            <div class="data-wrap-value">
              <div>--</div>
              <div>--</div>
            </div>
          </div>
          <div v-else class="master-info-wrap-right">
            <div class="data-wrap-name">
              <div>{{$t('upgrade_page_views_player_detail_index_1109')}}</div>
              <div>{{$t('upgrade_page_views_player_detail_index_1110')}}</div>
            </div>
            <div class="data-wrap-value">
              <div>{{ (userOrder.star ? userOrder.star / userOrder.starOrder : userOrder.star) | parseNum(1) }}({{ userOrder.starOrder }})</div>
              <div>{{ userOrder.order }}</div>
            </div>
            <div class="data-wrap-name">
              <div class="score-btn" @click="openScorePopup">
                <span>{{$t('upgrade_page_views_master_index_210')}}</span>
                <fps-icon type="question" size="18" color="rgba(99, 109, 134, 0.5)" />
              </div>
              <div>{{ viewMasterInfo.follower ? $t('upgrade_page_views_master_index_209') : ' '}}</div>
            </div>
            <div class="data-wrap-value">
              <div>{{ viewMasterInfo.playerScore | parseNum }}</div>
              <div>{{ viewMasterInfo.follower || ' ' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="comment-list">
        <div class="detail-title">
          <span>{{$t('upgrade_page_views_master_components_skill_info_comment_info_278')}}<span v-show="commentTotal"> ({{ commentTotal }})</span></span>
          <div class="star-count">
            <span>{{ (skillInfo.starRating || '') | parseNum(1) }}</span>
            <fps-star :count="skillInfo.starRating" :size="12" />
          </div>
        </div>
        <div v-if="gettingComment" class="loading-container">
          <i class="el-icon-loading"></i>
        </div>
        <div v-if="commentCateList && commentCateList.length" class="comment-cate">
          <div
            v-for="c in commentCateList"
            :key="`comment-cate-${c.id}`"
            class="one-comment-cate"
            :class="c.id === selectedCommentCateId && 'selected'"
          >{{ c.tag }}<span class="count">({{ c.count }})</span></div>
        </div>
        <div v-if="commentList.length" class="comment-list-wrap">
          <div
            v-for="(c, i) in commentList"
            :key="'comment-' + i"
            class="one-comment"
          >
            <fps-avatar class="comment-avatar pointer" :src="c.commentatorAvatarUrl" :borderMethod="c.giftRankOrder ? 2 : (c.giftRankOrder === 0 ? 1 : 0)" @click.native="openMasterDetail(c.commentatorUuid)" />
            <div class="info-wrap">
              <div class="nickname pointer" @click="openMasterDetail(c.commentatorUuid)">{{ c.commentatorName }}</div>
              <div class="comment-time">{{ new Date(c.createTime).$format('yyyy-MM-dd') }}</div>
              <div class="comment-content">
                <img v-if="c.recommendStatus === 'Recommend'" class="good-comment" src="~@/assets/image/icons/comment-good.png">
                {{ c.content }}
              </div>
              <div v-if="c.tags && c.tags.length" class="tags-list-wrap">
                <fps-icon type="tag" size="10" />
                {{ c.tags.map(tag => tag.tag).join('，') }}
              </div>
              <div v-if="isSelf && c.reply.status === 'CanReply' && !c.replying" class="reply-btn" @click="editReply(i)">
                <fps-icon type="reply" size="10" />{{$t('upgrade_page_views_master_components_skill_info_comment_info_279')}}</div>
              <div v-else-if="isSelf && c.reply.status === 'CanReply' && c.replying" class="replying-wrap">
                <div class="master-reply">
                  <span class="nickname">{{ viewMasterInfo.nickname }}</span>
                  <span>{{$t('upgrade_page_views_master_components_skill_info_comment_info_280')}}</span>
                </div>
                <textarea v-model="c.replyContent" class="reply-content" :placeholder="$t('upgrade_page_views_master_components_skill_info_comment_info_281')" />
                <div class="reply-btns">
                  <button class="cancel-btn" @click="cancelReply">{{$t('upgrade_page_layout_header_42')}}</button>
                  <button class="confirm-btn" :disabled="!c.replyContent" @click="finshReply">
                    <i v-if="c.replyLoading" class="el-icon-loading"></i>
                    <span v-else>{{$t('upgrade_page_views_player_list_index_182')}}</span>
                  </button>
                </div>
              </div>
              <div v-if="c.reply.status == 'HadReply' && c.reply.content" class="replying-wrap">
                <div class="master-reply">
                  <span class="nickname">{{ viewMasterInfo.nickname }}</span>
                  <span>{{$t('upgrade_page_views_master_components_skill_info_comment_info_280')}}</span>
                </div>
                <div class="replyed-content">{{ c.reply.content }}</div>
              </div>
            </div>
            <fps-star class="comment-star" :count="c.starRating" :size="10" />
          </div>
          <div v-if="commentFinshed" class="no-more-comment">{{$t('upgrade_page_views_master_components_skill_info_comment_info_282')}}</div>
          <div v-else-if="gettingComment" class="get-more-comment">
            <i class="el-icon-loading"></i>
          </div>
          <div v-else class="get-more-comment pointer" @click="getCommentList">
            <span>{{$t('upgrade_page_views_home_index_3')}}</span>
          </div>
        </div>
        <div v-else-if="!gettingComment" class="comment-empty">
          <img class="comment-empty-img" src="~@/assets/image/background/empty-comment.png">
          <span class="comment-empty-text">{{$t('upgrade_page_views_master_components_skill_info_comment_info_283')}}</span>
        </div>
      </div>
      <div v-if="!masterDialog && !quickMatchUuid && rankListActive && rankListActive.length" class="other-skill">
        <div class="skill-title">{{$t('upgrade_page_views_player_detail_skill_mobile_2135')}}</div>
        <div class="skill-wrap">
          <div class="skill-container">
            <div
              v-for="s in rankListActive"
              :key="'skill-' + s.id"
              class="one-skill"
              @click="openSkillDetail(s)"
            >
              <img class="game-image" :src="s.gameImageUrl + '?d=300x300'">
              <div class="game-name">{{ s.gameName }}</div>
              <div class="skill-price">
                <div class="sales-price">{{$t('upgrade_page_views_order_components_pay_info_343', [ salesPrice[s.id] ])}}<span>/{{ s.salesUnit | salesUnitTranslate }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScoreExplain
        v-model="scorePopupStatus"
        :popupType="scorePopupType"
        :score="viewMasterInfo.playerScore || 0"
        :isGood="viewMasterInfo && viewMasterInfo.alertScore"
      />
    </div>
  </div>
</template>
<script>
import i18n from '../../../locales/index'

import { mapGetters } from 'vuex'
import PhotoList from '@/components/PhotoList'
// import InputNumber from '@/components/InputNumber';
import TipBtn from '@/components/SkillDetail/TipBtn'
import ScoreExplain from '@/components/ScoreExplain'
export default {
  components: {
    PhotoList,
    // InputNumber,
    TipBtn,
    ScoreExplain,
  },
  data() {
    return {
      skillInfo: {},
      masterInfo: {},
      selectedModel: {},
      orderCount: 1,
      swipeIndex: 0,
      commentCateList: [],
      commentList: [],
      selectedCommentCateId: '',
      commentFinshed: false,
      gettingComment: false,
      commentTotal: 0,
      scorePopupStatus: false,
      scorePopupType: 'ScoreCExplain',
      showBackTop: false,
      showBottomOrder: false,
      userUuid: this.$route.params.uuid,
      masterDialog: this.$route.params.uuid ? false : true,
      skillId: +(this.$route.params.skillId),
      quickMatchUuid: +(this.$route.query.quickId),
      displayWidth: window.screen.width - 32,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo', 'viewMasterInfo', 'loadingViewMasterInfo']),
    isSelf() {
      return this.userInfo && this.userInfo.uuid === (this.userUuid || this.viewMasterInfo.uuid)
    },
    isOnline() {
      return this.$util.isOnline(this.skillInfo)
    },
    labelList() {
      return this.$util.computedTags((this.skillInfo.labelList || [])).concat(this.$util.computedTags(this.skillInfo.labelList || [], 'comment').slice(0, 2))
    },
    showLolTag() {
      if (!this.skillInfo.labelList) return false
      return this.skillInfo.labelList.some(item => item.labelId > 1000 && item.labelId < 10000)
    },
    newComerCouponList() {
      if (!this.accountInfo) return []
      return (this.accountInfo.couponInfoList || []).filter(
        (item) => {
          return item.couponTemplate == 'NEWCOMER_EXPERIENCE' && item.couponStatus === 'EFFECT';
        }
      )
    },
    userOrder() {
      const defaultData = { star: 0, starOrder: 0, order: 0 }
      if (!this.viewMasterInfo.uuid) return defaultData
      return this.viewMasterInfo.playerSkillVoList.reduce((rs, item) => {
        rs.star += item.starRating * item.countComment
        rs.starOrder += item.countComment
        rs.order += item.countTransactions
        return rs
      }, defaultData)
    },
    screenshotImageUrlList() {
      if (this.skillInfo.screenshotImageUrlList) {
        return JSON.parse(this.skillInfo.screenshotImageUrlList)
      } else if (this.skillInfo.screenshotImageUrl) {
        return [this.skillInfo.screenshotImageUrl]
      } else return []
    },
    // 計算每個技能的基礎價格
    salesPrice() {
      if (!this.viewMasterInfo.playerSkillVoList) return {}
      return this.viewMasterInfo.playerSkillVoList.reduce((rs, skill) => {
        const showPrice = this.$util.computedPrice(skill)
        rs[skill.id] = showPrice === '' ? skill.salesPrice : showPrice
        return rs
      }, {})
    },
    discountList() {
      const list = []
      if (!this.userInfo) {
        this.newDiscountList(list)
        list.push(i18n.t('upgrade_page_views_master_components_skill_info_base_info_270', [ this.$util.newerDiscount ]))
      } else if (this.newComerCouponList[0]) {
        this.newDiscountList(list)
        list.push(i18n.t('upgrade_page_views_master_components_skill_info_base_info_270', [ this.newComerCouponList[0].couponAmount ]))
      } else if (this.skillInfo.firstOrderPrivilege && this.selectedModel.id === 0) {
        list.push(i18n.t('upgrade_page_views_player_list_index_196'))
      }
      return list
    },
    rankListActive() {
      if (this.masterDialog || !this.viewMasterInfo.playerSkillVoList) return []
      return this.viewMasterInfo.playerSkillVoList.filter(item => item.id !== this.skillInfo.id)
    },
  },
  watch: {
    skillId() {
      this.getDefaultData()
    },
    skillInfo(info) {
      if (info) {
        this.setDefaultPrice()
        this.reportVisitor()
      }
    },
  },
  created() {
    this.getDefaultData()
    this.reportVisitor()
  },
  beforeDestroy() {
    window.document.body.style.overflow = 'auto'
  },
  methods: {
    backTop() {
      this.$refs.page_top.scrollIntoView({
        behavior: 'smooth',
      })
    },
    openScorePopup() {
      let userKind = this.viewMasterInfo && this.viewMasterInfo.userKind;
      // 如果是自己并且查看的是b端用户
      if (this.isSelf && userKind === 'Player') {
        this.scorePopupType = 'ScoreBExplain';
      } else {
        this.scorePopupType = 'ScoreCExplain';
      }
      this.scorePopupStatus = true;
    },
    // 切换轮播
    swipeChange(method, refName) {
      const $swipe = this.$refs[refName]
      if (!$swipe) return
      $swipe[method]()
    },
    changeSwipe(swipeIndex) {
      this.swipeIndex = swipeIndex
    },
    newDiscountList(list) {
      if (this.selectedModel.id === 0 && this.skillInfo.redBagFreeFlag && this.skillInfo.selfSpreadDiscount) {
        list.push(i18n.t('upgrade_page_views_master_components_skill_info_base_info_271', [this.skillInfo.selfSpreadDiscount * 10]))
      }
    },
    selectPrice(model) {
      model ? (this.selectedModel = model) : this.setDefaultPrice()
    },
    setDefaultPrice() {
      this.selectedModel = {
        id: 0,
        name: i18n.t('upgrade_page_views_master_components_skill_info_base_info_269'),
        price: this.skillInfo.price,
        showPrice: this.$util.computedPrice(this.skillInfo) !== '' ? this.$util.computedPrice(this.skillInfo) : this.skillInfo.salesPrice,
        salesUnit: this.skillInfo.salesUnit,
      }
    },
    getDefaultData() {
      this.selectedModel = {}
      this.swipeIndex = 0
      if (this.userUuid) {
        this.skillInfo = {}
        if (this.userUuid !== this.viewMasterInfo.uuid) {
          this.getMasterInfo()
        } else {
          this.getSkillInfo()
        }
      } else {
        this.getSkillInfo()
      }
      this.getDefaultComment()
    },
    getDefaultComment() {
      this.commentCateList = []
      this.commentList = []
      this.selectedCommentCateId = ''
      this.commentFinshed = false
      this.gettingComment = false
      this.lastItemId = ''
      this.commentTotal = 0
      this.notFirst = false
      this.getCommentList()
    },
    changeSkill(skill) {
      this.skillInfo = skill
      this.getDefaultComment()
      this.backTop()
    },
    getCommentList() {
      const playerUserUuid = this.userUuid || this.viewMasterInfo.uuid
      if (this.commentFinshed || this.gettingComment || !playerUserUuid) return
      this.gettingComment = true
      const offset = this.notFirst ? 10 : 6
      const playerSkillId = this.skillId
      this.$http.get('comment/list', {
        lastItemId: this.lastItemId,
        offset,
        playerUserUuid,
        playerSkillId,
      }).then(({ data })=> {
        if (this.skillInfo.id && playerSkillId !== this.skillInfo.id) return
        if (!this.notFirst) {
          this.commentCateList = data.tagStatic
          this.commentTotal = data.totalRemain
          this.notFirst = true
        }
        if (data.pageContent.length) {
          this.commentList = this.commentList.concat(data.pageContent)
          this.lastItemId = data.pageContent[data.pageContent.length - 1].id
        }
        if (data.pageContent.length < offset || this.commentTotal === this.commentList.length) {
          this.commentFinshed = true
        }
        this.gettingComment = false
      }).catch(() => {
        if (playerSkillId !== this.skillInfo.id) return
        this.gettingComment = false
      })
    },
    reportVisitor() {
      if (!this.userUuid || !this.skillInfo.gameName) return
      // C端查看B端技能上報
      this.$http.post('/visit/report/skill', {
        gameName: this.skillInfo.gameName,
        reportedUuid: this.userUuid,
      });
      this.$adjust('web_check_skill', {
        player_uuid: this.userUuid,
        skill_id: this.skillInfo.id,
        game_id: this.skillInfo.gameId,
      })
    },
    openChat() {
      window.loadApp({
        title: i18n.t('upgrade_page_views_player_detail_skill_mobile_2136', [ this.viewMasterInfo.nickname ]),
        content: i18n.t('upgrade_page_views_player_detail_skill_mobile_2137', [ this.viewMasterInfo.sex === 'Male' ? '他' : '她' ]),
        showCancelButton: false,
        showClose: true,
      })
    },
    openOrderPage() {
      window.loadApp({
        title: i18n.t('upgrade_page_views_player_detail_skill_mobile_2138', [ this.viewMasterInfo.nickname ]),
        content: i18n.t('upgrade_page_views_player_detail_skill_mobile_2139', [ this.viewMasterInfo.sex === 'Male' ? '他' : '她' ]),
        showCancelButton: false,
        showClose: true,
      })
    },
    getMasterMusk() {
      this.$http.get('/user/chart/guide').then(({ data }) => {
        this.masterMusk = data;
      });
    },
    async getMasterInfo() {
      if (this.userUuid !== this.viewMasterInfo.uuid) {
        await this.$store.dispatch('app/getMasterInfo', { uuid: this.userUuid })
      }
      this.getSkillInfo()
    },
    getSkillInfo() {
      if (!this.viewMasterInfo.playerSkillVoList || !this.viewMasterInfo.playerSkillVoList.length) return
      this.skillInfo = this.viewMasterInfo.playerSkillVoList.find(item => item.id === this.skillId) || {}
    },
    openMasterDetail(userUuid) {
      if (this.quickMatchUuid) return
      this.$router.push({
        path: `/player-detail/${ userUuid || this.userUuid }`,
        query: {
          isHome: this.$route.query.isHome,
        }
      })
    },
    editReply(index) {
      if (this.lastCommentIndex !== undefined) {
        const lastComment = this.commentList[this.lastCommentIndex]
        lastComment.replying = false
        this.commentList.splice(this.lastCommentIndex, 1, lastComment)
      }
      const nextComment = this.commentList[index]
      nextComment.replying = true
      this.commentList.splice(this.index, 1, nextComment)
      this.lastCommentIndex = index
    },
    cancelReply() {
      if (this.lastCommentIndex !== undefined) {
        const lastComment = this.commentList[this.lastCommentIndex]
        lastComment.replying = false
        this.commentList.splice(this.lastCommentIndex, 1, lastComment)
        this.lastCommentIndex = undefined
      }
    },
    finshReply() {
      const { lastCommentIndex } = this
      if (lastCommentIndex === undefined) return
      const lastComment = this.commentList[this.lastCommentIndex]
      lastComment.replyLoading = true
      this.commentList.splice(this.lastCommentIndex, 1, lastComment)
      this.$http.post('/comment/player/writeReply', {
        orderCommentId: lastComment.reply.orderCommentId,
        content: lastComment.replyContent,
      }).then(() => {
        lastComment.replyLoading = false
        lastComment.replying = false
        lastComment.reply.content = lastComment.replyContent
        lastComment.reply.status = 'HadReply'
        lastComment.createTime = Date.now()
        this.lastCommentIndex = undefined
        this.commentList.splice(this.lastCommentIndex, 1, lastComment)
      }).catch(({ msg }) => {
        lastComment.replyLoading = false
        this.commentList.splice(this.lastCommentIndex, 1, lastComment)
        this.$message.error(msg)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .visible-arrow {
    opacity: 1 !important;
  }
  .custom-swiper-banner {
    margin-top: 24px;
  }
  .score-btn {
    @include flex;
    &:hover {
      cursor: pointer;
      span {
        color: $color-link !important;
        text-decoration: underline;
      }
    }
  }
  .loading-container {
    @include flex;
    font-size: 20px;
    margin-top: 20px;
  }
  .label-text {
    padding: 16px 0 25px 24px;
    .title {
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: $color-gray-1;
      text-align: left;
    }
    ul {
      margin-top: 12px;
      li {
        @include flex(flex-start);
        font-size: 12px;
        line-height: 16px;
        color: $color-gray-2;
        &:not(:first-child) {
          margin-top: 8px;
        }
        .tag-wrap {
          font-size: 12px;
          line-height: 16px;
          &::before{
            width: 16px;
            height: 16px;
          }
          margin-right: 6px;
        }
      }
    }
  }
  .dialog-clear-style-wrap {
    & /deep/ .dialog-clear-style {
      max-width: 100vw;
      width: 100vw;
    }
  }
  .scroll-wrap {
    overflow-y: auto;
    @include hideScrollBar(0, 0);
    // width: 100vw;
    // height: 100vh;
    // position: relative;
    .page-top {
      width: 100%;
      height: 1px;
      margin-bottom: 15px;
    }
    .back-top {
      position: fixed;
      left: 50%;
      bottom: 48px;
      transform: translate(440px);
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: rgba(255, 255, 255, .2);
      @include flex;
      cursor: pointer;
    }
    .close-skill-detail {
      position: fixed;
      top: 32px;
      right: 32px;
    }
    .skill-slide {
      position: fixed;
      top: 32px;
      left: 50%;
      transform: translateX(440px);
      @include flex(flex-start, center, column);
      .user-image {
        width: 40px !important;
        height: 40px !important;
        margin-bottom: 16px;
        // border: 2px solid #fff;
      }
      .im-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: rgba(255, 255, 255, .2);
        @include flex;
      }
    }
  }
  .skill-detail-dialog {
    width: 100%;
    margin: 0 auto;
    background: #fff;
    padding: 0 16px 36px;
    border: 1px solid #EFEFEF;
    position: relative;
  }
  .skill-detail-title {
    @include flex(flex-start);
    font-size: 12px;
    line-height: 16px;
    color: $color-gray-2;
    margin-bottom: 24px;
    .user-image {
      width: 32px !important;
      height: 32px !important;
    }
    .nickname {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      margin-left: 8px;
      margin-right: 20px;
    }
    .online-circle-wrap {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: $color-offline;
      &.is-online-wrap {
        background: $color-green;
      }
    }
    .online-text {
      margin-left: 2px;
    }
    .reply-count {
      margin-left: 16px;
    }
  }
  .detail-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    color: $color-gray-1;
    margin-top: 48px;
  }
  .skill-top {
    .game-image {
      width: 164px;
      border-radius: 4px;
    }
  }
  .skill-info {
    margin-top: 16px;
    .skill-name {
      font-weight: 600;
      font-size: 24px;
      line-height: 34px;
      color: $color-gray-1;
    }
    .order-state {
      @include flex(flex-start);
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-2;
      margin-top: 4px;
      .order-count {
        @include flex(flex-start);
      }
      .stronger {
        font-weight: 500;
        margin: 0 2px;
      }
      .line {
        width: 1px;
        height: 12px;
        background: $color-split;
        margin: 0 16px;
      }
      .order-score {
        margin-left: 8px;
        @include flex;
        span {
          margin-left: 2px;
        }
      }
    }
    .display-price {
      margin-top: 32px;
      .price {
        @include flex(flex-start, flex-end);
        .sale-price {
          font-weight: 600;
          font-size: 24px;
          line-height: 34px;
          color: $color-price;
          margin-right: 2px;
        }
        .sale-unit {
          font-weight: 500;
          font-size: 12px;
          line-height: 24px;
          color: $color-price;
          margin-left: 2px;
        }
        .old-price {
          font-weight: 500;
          font-size: 12px;
          line-height: 24px;
          margin-left: 8px;
          text-decoration-line: line-through;
          color: $color-gray-3;
        }
      }
      .price-onecoin {
        flex-shrink: 0;
        @include flex(flex-start);
        width: 100%;
        margin-top: 6px;
        div {
          @include flex;
          position: relative;
          overflow: hidden;
          height: 18px;
          line-height: 18px;
          padding: 0 4px 0 52px;
          color: $color-orange;
          font-size: 12px;
          border: 1PX solid $color-orange;
          border-radius: 2px;
          span {
            @include flex;
            position: absolute;
            left: -2px;
            top: 50%;
            transform: translateY(-50%);
            width: 50px;
            height: 36px;
            background: $color-orange;
            color: #fff!important;
            font-size: 12px!important;
            font-weight: 800;
          }
        }
      }
      .discount-list {
        @include flex(flex-start);
        margin-top: 6px;
        height: 20px;
        .one-discount {
          padding: 2px 8px;
          height: 100%;
          @include flex;
          font-size: 12px;
          line-height: 1;
          color: #FF6610;
          background: rgba(254, 127, 56, 0.15);
          border-radius: 34px;
        }
      }
    }
    .tool-button-bottom {
      width: 100%;
      height: 1px;
    }
    .discount-price {
      height: 16px;
    }
    .select-wrap {
      @include flex(flex-start, flex-start);
      line-height: 22px;
      &:not(:first-child) {
        margin-top: 20px;
      }
      &.select-price {
        line-height: 28px;
        margin-top: 28px;
        .select-left {
          margin-top: 8px;
        }
      }
      &.give-away {
        line-height: 18px;
      }
      .select-left {
        width: 72px;
        font-size: 14px;
        color: $color-gray-2;
        text-align: left;
      }
      .select-right {
        @include flex(flex-start, flex-start);
        flex-wrap: wrap;
        flex: 1;
      }
      .model-price {
        padding: 0 8px;
        height: 28px;
        border: 1px solid #E8EAEE;
        border-radius: 4px;
        font-weight: 500;
        font-size: 12px;
        color: $color-gray-2;
        cursor: pointer;
        @include flex;
        margin: 8px 8px 0 0;
        &.selected {
          background: #FFFBF9;
          border: 1px solid #E49F78;
          font-weight: 500;
          color: $color-gray-1;
        }
        .model-name {
          margin-right: 8px;
        }
      }
      .one-give-away {
        font-size: 12px;
        height: 18px;
        padding: 0 4px;
        border-radius: 4px;
        color: #EA320A;
        border: 1px solid #FFEAE6;
        &:not(:first-child) {
          margin-left: 6px;
        }
      }
    }
  }
  .tool-buttons {
    @include flex(flex-start);
    margin-top: 64px;
    button {
      width: 160px;
      height: 48px;
      font-weight: 500;
      font-size: 16px;
      color: $color-gray-1;
      border-radius: 50px;
      @include flex;
    }
    .chat-btn {
      margin-right: 16px;
      @include button-yellow;
      &-text {
        margin-left: 10px;
      }
    }
    .order-btn {
      @include button-yellow;
    }
  }
  .skill-description {
    .description-text {
      margin-top: 16px;
      font-size: 14px;
      line-height: 22px;
      color: $color-gray-2;
    }
    .skill-voice {
      width: 200px;
      height: 40px;
      margin-top: 16px;
    }
    .skill-description-tags {
      margin-top: 16px;
      @include flex(space-between);
      .tags-list {
        @include flex(flex-start);
        & > div {
          height: 24px !important;
          &::before {
            width: 20px;
            height: 20px;
          }
          &:not(:first-child) {
            margin-left: 8px;
          }
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: $color-split;
      margin: 24px 0;
    }
    .skill-attr {
      margin-bottom: 8px;
      @include flex(flex-start);
      font-size: 14px;
      line-height: 20px;
      &-name {
        width: 96px;
        text-align: left;
        color: $color-gray-2;
      }
      &-value {
        color: $color-gray-1;
      }
    }
    .pubg-kda {
      margin-top: 8px;
      @include flex(flex-start);
      .nicee-certification {
        height: 16px;
        margin-right: 6px;
      }
      span {
        color: $color-gray-2;
        margin-right: 20px;
      }
    }
  }
  .master-info {
    .master-info-wrap {
      margin-top: 16px;
      padding: 24px;
      background: #F9F9F9;
      border: 1px solid $color-button;
      border-radius: 4px;
      &-left {
        flex: 1;
        @include flex(flex-start);
        .user-avatar {
          width: 64px;
          height: 64px;
          position: relative;
          margin-right: 15px;
          .online-state {
            width: 16px;
            height: 16px;
            position: absolute;
            right: 0;
            bottom: 0;
            border: 2px solid #fff;
            border-radius: 50%;
            background: $color-offline;
            &.is-online-wrap {
              background: $color-green;
            }
          }
        }
        &-other {
          @include flex(center, flex-start, column);
          .user-nickname {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: $color-gray-1;
          }
          .tool-btns {
            @include flex(flex-start);
            margin-top: 8px;
            button {
              width: 88px;
              height: 28px;
              @include flex;
              font-size: 12px;
              box-sizing: border-box;
              border-radius: 50px;
              span {
                margin-left: 6px;
              }
              @include button-gray-2;
              color: $color-gray-2;
              border: 1px solid #636D86;
            }
            .chat-btn {
              margin-right: 8px;
            }
          }
        }
      }
      &-right {
        margin-top: 31px;
        @include flex(flex-start);
        .data-wrap-name {
          font-size: 14px;
          line-height: 20px;
          color: $color-gray-1;
          margin-right: 8px;
          text-align: left;
          &>div {
            height: 20px;
          }
          &>div:not(:first-child) {
            margin-top: 8px;
          }
        }
        .data-wrap-value {
          font-weight: 500;
          font-size: 14px;
          line-height: 20px;
          color: $color-price;
          text-align: left;
          &>div {
            height: 20px;
          }
          &>div:not(:first-child) {
            margin-top: 8px;
          }
          &:not(:last-child) {
            width: 100px;
          }
        }
        .loading-wrap .data-wrap-value {
          color: $color-gray-3;
        }
      }
    }
  }
  .comment-list {
    .detail-title {
      @include flex(space-between);
      .star-count {
        @include flex;
        span {
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          color: $color-gray-2;
          margin-right: 8px;
        }
      }
    }
    .comment-cate {
      @include flex(flex-start, flex-start);
      flex-wrap: wrap;
      margin-top: 6px;
      .one-comment-cate {
        margin: 10px 8px 0 0;
        padding: 3.5px 10px;
        border: 1px solid rgba(140, 148, 170, 0.3);
        border-radius: 50px;
        font-size: 12px;
        line-height: 17px;
        color: $color-gray-2;
        cursor: default;
        @include flex;
        span {
          margin-left: 6px; 
        }
        &.selected {
          border-color: $color-link;
          background: rgba(0, 122, 255, 0.1);
          color: $color-link;
        }
      }
    }
    &-wrap {
      display: flex;
      flex-direction: column;
      margin-top: 12px;
      .one-comment {
        margin-top: 12px;
        padding: 16px 0;
        @include flex(flex-start, flex-start);
        position: relative;
        $comment-first: 50px;
        .comment-star {
          position: absolute;
          top: $comment-first / 2;
          right: 0;
          transform: translateY(-50%);
        }
        .comment-avatar {
          width: $comment-first;
          height: $comment-first;
          margin-right: 16px;
        }
        .info-wrap {
          @include flex(flex-start, flex-start, column);
          flex: 1;
          .nickname {
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            color: $color-gray-1;
          }
          .comment-time {
            font-weight: 500;
            font-size: 12px;
            line-height: 16px;
            color: rgba(99, 109, 134, 0.5);
            margin-top: 2px;
          }
          .comment-content {
            width: 100%;
            margin-top: 16px;
            font-size: 14px;
            line-height: 22px;
            color: $color-gray-2;
            position: relative;
            .good-comment {
              position: absolute;
              width: 30px;
              right: 0;
              top: -20px;
            }
          }
          .tags-list-wrap {
            @include flex;
            margin-top: 8px;
            padding: 3.5px 8px;
            background: $color-button;
            border-radius: 50px;
            font-size: 12px;
            line-height: 17px;
            letter-spacing: -0.000319808px;
            color: $color-gray-3;
          }
          .reply-btn {
            margin-top: 8px;
            align-self: flex-end;
            font-size: 12px;
            line-height: 16px;
            color: $color-gray-1;
            @include flex;
            cursor: pointer;
            & > i {
              margin-right: 5px;
            }
          }
          .replying-wrap {
            margin-top: 16px;
            background: rgba($color: $color-gray-3, $alpha: .1);
            border-radius: 4px;
            padding: 16px;
            width: 100%;
            @include flex(flex-start, flex-start, column);
            .master-reply {
              @include flex;
              font-weight: 500;
              font-size: 14px;
              line-height: 20px;
              color: $color-gray-2;
              .nickname {
                margin-right: 4px;
                color: $color-gray-1;
              }
            }
            .replyed-content {
              margin-top: 4px;
              font-size: 14px;
              line-height: 22px;
              color: $color-gray-2;
            }
            .reply-content {
              margin-top: 8px;
              background: #FFFFFF;
              border: 1px solid $color-split;
              border-radius: 4px;
              padding: 12px 20px 0 12px;
              font-size: 14px;
              line-height: 22px;
              color: $color-gray-2;
              width: 100%;
              height: 90px;
              resize: none;
            }
            .reply-btns {
              align-self: flex-end;
              margin-top: 8px;
              @include flex;
              button {
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
              }
              .cancel-btn {
                color: $color-gray-3;
              }
              .confirm-btn {
                color: $color-link;
                margin-left: 16px;
                &:disabled {
                  background: transparent !important;
                  opacity: .3;
                  color: $color-link !important;
                }
              }
            }
          }
        }
      }
      .no-more-comment,
      .get-more-comment {
        margin: 24px auto 0;
        width: 116px;
        height: 36px;
        @include flex;
        text-align: center;
        border-radius: 50px;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.000319808px;
        color: $color-gray-2;
      }
      .no-more-comment {
        color: $color-gray-3;
      }
      .get-more-comment {
        border: 1px solid $color-split;
      }
    }
    .comment-empty {
      @include flex(flex-start, center, column);
      margin-top: 34px;
      &-img {
        width: 140px;
      }
      &-text {
        margin-top: 15px;
        font-size: 14px;
        line-height: 20px;
        color: $color-gray-2;
      }
    }
  }
  .other-skill {
    .skill-title {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: $color-gray-1;
      margin: 24px 0 16px;
    }
    .skill-wrap {
      width: 100%;
      overflow-x: auto;
      padding-bottom: 8px;
      .skill-container {
        font-size: 0;
        white-space: nowrap;
        .one-skill {
          width: 136px;
          vertical-align: middle;
          display: inline-block;
          text-align: center;
          &:not(:first-child) {
            margin-left: 18px;
          }
          .game-image {
            width: 136px;
            border-radius: 4px;
          }
          .game-name {
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: $color-gray-1;
            margin: 8px 0 4px;
          }
          .skill-price {
            font-weight: 600;
            font-size: 14px;
            line-height: 20px;
            color: $color-price;
          }
        }
      }
    }
  }

</style>
